/**
 * Father-dossier DECLASSIFICATION reveal — the reward beat that follows a rank-up.
 * Deliberately SEQUENCED after the RankUp ceremony (never concurrent): the promotion
 * is absorbed first, then a true file on his father declassifies as its own moment.
 * Same security-terminal family as RankUp; the unique move is the redaction wiping
 * off to reveal the file, punctuated by the DECLASSIFIED stamp. JARVIS narrates the
 * file itself by voice while this holds (see the [FATHER DOSSIER] message in KidMode).
 */
import { useEffect, useRef } from "react";

export default function DeclassifyReveal({
  title,
  rank,
  holdMs = 13000,
  onDone,
}: {
  title: string;
  rank: string;
  holdMs?: number;
  onDone: () => void;
}) {
  // Dismiss timer must fire ONCE, not reset on every parent re-render (the child-state
  // poll re-renders ~every 4s and onDone is a fresh closure each time — if it were in
  // the deps the 13s timer would reset forever and the card would never dismiss).
  const onDoneRef = useRef(onDone);
  onDoneRef.current = onDone;
  useEffect(() => {
    const t = setTimeout(() => onDoneRef.current(), holdMs);
    return () => clearTimeout(t);
  }, [holdMs]);

  const r = (rank || "").toUpperCase();
  return (
    <div className="kid-declass" role="alert">
      <div className="kid-declass__scan" />
      <div className="kid-declass__auth">◈ CLEARANCE VERIFIED · LEVEL: {r} ◈</div>
      <div className="kid-declass__file">
        <span className="kid-declass__corner kid-declass__corner--tl" />
        <span className="kid-declass__corner kid-declass__corner--tr" />
        <span className="kid-declass__corner kid-declass__corner--bl" />
        <span className="kid-declass__corner kid-declass__corner--br" />
        <div className="kid-declass__sheen" />
        <div className="kid-declass__head">Dossier Papa</div>
        <div className="kid-declass__subject">
          Sujet : <b>Papa</b>
        </div>
        <div className="kid-declass__titlewrap">
          <div className="kid-declass__title">{(title || "").toUpperCase()}</div>
          <div className="kid-declass__redaction" />
          <div className="kid-declass__wipe" />
        </div>
        <div className="kid-declass__stamp">Declassified</div>
        <div className="kid-declass__foot">Eyes Only · Cleared to {rank}</div>
      </div>
    </div>
  );
}
